import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";

const HeroCarousel = ({ banners }) => {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    if (!banners.length) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % banners.length), 6000);
    return () => clearInterval(t);
  }, [banners.length]);
  if (!banners.length) return null;
  const b = banners[idx];
  return (
    <div className="relative rounded-2xl overflow-hidden bg-[#2D5A47] text-white shadow-xl min-h-[420px] lg:min-h-[520px]" data-testid="hero-carousel">
      <img
        src={b.image_desktop}
        alt={b.title}
        loading={idx === 0 ? "eager" : "lazy"}
        decoding="async"
        fetchPriority={idx === 0 ? "high" : "low"}
        className="absolute inset-0 w-full h-full object-cover hero-fade-enter"
        key={b.id}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#1E2923]/90 via-[#1E2923]/60 to-transparent p-8 lg:p-16 flex flex-col justify-center max-w-7xl">
        <div className="hero-fade-enter" key={`t-${b.id}`}>
          <div className="text-xs tracking-[0.3em] uppercase text-[#D99B26] mb-4">Eira Presents</div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] max-w-2xl">{b.title}</h1>
          {b.subtitle && <p className="mt-5 max-w-xl text-white/80 text-base sm:text-lg leading-relaxed">{b.subtitle}</p>}
          <Link to={b.cta_link || "/shop"} className="inline-block mt-8 bg-[#C86D42] hover:bg-[#AE5931] px-8 py-3.5 rounded-lg font-semibold shadow-lg transition active:scale-[0.98]" data-testid="hero-cta">
            {b.cta_text || "Shop Now"} →
          </Link>
        </div>
      </div>
      <button onClick={() => setIdx((i) => (i - 1 + banners.length) % banners.length)} className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/20 backdrop-blur hover:bg-white/30 rounded-full p-2">
        <ChevronLeft />
      </button>
      <button onClick={() => setIdx((i) => (i + 1) % banners.length)} className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/20 backdrop-blur hover:bg-white/30 rounded-full p-2">
        <ChevronRight />
      </button>
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
        {banners.map((_, i) => (
          <button key={i} onClick={() => setIdx(i)} className={`h-1.5 rounded-full transition-all ${i === idx ? "w-8 bg-[#C86D42]" : "w-4 bg-white/40"}`} />
        ))}
      </div>
    </div>
  );
};

export default HeroCarousel;
